class RegistrationInfo {
  construction() {
    this.ActivationCode = '';
    this.MemberID = '';
    this.FirstName = '';
    this.MiddleName = '';
    this.LastName = '';
    this.DateOfBirth = '';
    this.ZipCode = '';
    this.SocialSecurity = '';
    this.Plan = '';
    this.EmailAddr = '';
    this.ConfirmEmailAddr = '';
    this.ContactNumber = '';
    this.Password = '';
    this.ConfirmPassword = '';
    this.submitStatus = false;
    this.pwdValid = false;
    this.confPwdValid = false;
  }

  getActivationCode() {
    return this.ActivationCode;
  }

  setActivationCode(ActivationCode) {
    this.ActivationCode = ActivationCode;
  }

  getMemberID() {
    return this.MemberID;
  }

  setMemberID(MemberID) {
    this.MemberID = MemberID;
  }

  getFirstName() {
    return this.FirstName;
  }

  setFirstName(FirstName) {
    this.FirstName = FirstName;
  }

  getMiddleName() {
    return this.MiddleName;
  }

  setMiddleName(MiddleName) {
    this.MiddleName = MiddleName;
  }

  getLastName() {
    return this.LastName;
  }

  setLastName(LastName) {
    this.LastName = LastName;
  }

  getDateOfBirth() {
    return this.DateOfBirth;
  }

  setDateOfBirth(DateOfBirth) {
    this.DateOfBirth = DateOfBirth;
  }

  getZipCode() {
    return this.ZipCode;
  }

  setZipCode(ZipCode) {
    this.ZipCode = ZipCode;
  }

  getSocialSecurity() {
    return this.SocialSecurity;
  }

  setSocialSecurity(SocialSecurity) {
    this.SocialSecurity = SocialSecurity;
  }

  getPlan() {
    return this.Plan;
  }

  setPlan(Plan) {
    this.Plan = Plan;
  }

  getEmailAddr() {
    return this.EmailAddr;
  }

  setEmailAddr(EmailAddr) {
    this.EmailAddr = EmailAddr;
  }

  getConfirmEmailAddr() {
    return this.ConfirmEmailAddr;
  }

  setConfirmEmailAddr(ConfirmEmailAddr) {
    this.ConfirmEmailAddr = ConfirmEmailAddr;
  }

  getContactNumber() {
    return this.ContactNumber;
  }

  setContactNumber(ContactNumber) {
    this.ContactNumber = ContactNumber;
  }

  getPassword() {
    return this.Password;
  }

  setPassword(Password) {
    this.Password = Password;
  }

  getConfirmPassword() {
    return this.ConfirmPassword;
  }

  setConfirmPassword(ConfirmPassword) {
    this.ConfirmPassword = ConfirmPassword;
  }

  getSubmitStatus() {
    return this.submitStatus;
  }

  setSubmitStatus(submitStatus) {
    this.submitStatus = submitStatus;
  }

  getPwdValid() {
    return this.pwdValid;
  }

  setPwdValid(pwdValid) {
    this.pwdValid = pwdValid;
  }

  getConfPwdValid() {
    return this.confPwdValid;
  }

  setConfPwdValid(confPwdValid) {
    this.confPwdValid = confPwdValid;
  }

  resetRegistrationInfo() {
    this.ActivationCode = '';
    this.MemberID = '';
    this.FirstName = '';
    this.LastName = '';
    this.DateOfBirth = '';
    this.ZipCode = '';
    this.SocialSecurity = '';
    this.Plan = '';
    this.EmailAddr = '';
    this.ConfirmEmailAddr = '';
    this.ContactNumber = '';
    this.Password = '';
    this.ConfirmPassword = '';
    this.pwdValid = false;
    this.confPwdValid = false;
    this.submitStatus = false;
  }
}
export default new RegistrationInfo();
